import { useLocation, useNavigate } from 'react-router';

export function useNavigateIfNeeded() {
  const location = useLocation();
  const navigate = useNavigate();

  return function navigateIfNeeded(desiredPath: string) {
    if (location.pathname !== desiredPath) {
      navigate(desiredPath);
    }
  };
}
